<script>
	const _ = require('underscore');

	module.exports = {
		props: ['article', 'assessment', 'totalAnnotations', 'routeContext', 'paragraphsNumbered', 'whiteboardView'],
		modelData: ['student'],

		components: {
			'content-body': require('components/content-body.vue').default
		},

		data: function () {
			return {
				selectedArticle: null
			};
		},

		computed: {
			articleList() {
				let assessment = this.assessment;
				let article = this.article;
				let articles = null;

				if (!article || !assessment) {
					return [];
				}

				switch (article.productType) {
					case 'AAD':
						// "articleList" is alphabetized array for AAD
						articles = _.filter(article.articleList, function (a) {
							return a.uuid in assessment.articles;
						});
						break;
					case 'P':
						articles = article.articleList.slice();
				}

				return articles;
			},
			supplementalTexts() {
				let article = this.article;
				let texts = null;

				if (article && article.supplemental_texts) {
					texts = {};
					if (article.supplemental_texts.challenge) {
						texts = _.assign({}, texts, article.supplemental_texts.challenge);
					}
					if (article.supplemental_texts.support) {
						texts = _.assign({}, texts, article.supplemental_texts.support);
					}
				}

				return texts;
			}
		},

		methods: {
			onArticleSelect(pid) {
				let article = this.article;
				let supplementalTexts = this.supplementalTexts;

				if (article) {
					if (article.articles && !article.sr) {
						if (article.articles[pid]) {
							this.selectedArticle = article.articles[pid];
						} else if (supplementalTexts && supplementalTexts[pid]) {
							this.selectedArticle = supplementalTexts[pid];
						}
					} else {
						this.selectedArticle = article;
					}
				}
			}
		},

		watch: {
			article: {
				handler: function (val) {
					if (val.articles && !val.sr) {
						var articleList = this.articleList;

						if (articleList && articleList.length) {
							this.onArticleSelect(articleList[0].uuid);
						}
					} else {
						this.onArticleSelect(val.uuid);
					}
				},
				immediate: true
			}
		}
	};
</script>
<template>
	<content-body
		class="assessment-article wrapper"
		:article="article"
		:article-list="articleList"
		:selected-article="selectedArticle"
		:route-context="routeContext"
		:on-article-select="onArticleSelect"
		:show-audio="assessment && assessment.options.au"
		:show-challenge="assessment && assessment.options.challenge"
		:show-support="assessment && assessment.options.support"
		:student="student"
		:force-highlighting="whiteboardView"
		:paragraphs-numbered="paragraphsNumbered"
		:annotations="totalAnnotations"
		:has-workspace="assessment && student && assessment.students[student].hasWorkspace">
	</content-body>
</template>
